import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

import { PwaInstallPromptService } from './core/services/pwa-install-prompt-service';
import { PostHogService } from './core/services/posthog.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  protected readonly pwaInstallPrompt = inject(PwaInstallPromptService);
  private readonly posthogService = inject(PostHogService);

  ngOnInit(): void {
    this.posthogService.init(environment.posthogKey, {
      api_host: environment.posthogHost,
      capture_exceptions: true,
      session_recording: {
        blockSelector: '.whatsapp-pairing-private',
        // Conversas do assistente não entram na telemetria (o painel usa `ph-no-capture`).
        maskCapturedNetworkRequestFn: (request) =>
          request.name.includes('/assistant/') ? null : request,
      },
    });
  }

  protected dismissPwaInstallPrompt(): void {
    this.pwaInstallPrompt.dismiss();
  }

  protected installPwa(): void {
    void this.pwaInstallPrompt.install();
  }
}
